# See ./README.md for usage.
angular.module("rjmNg.common.tagSelector").directive "tagSelector", [
  () ->
    bindToController: true
    controllerAs: "view"
    restrict: "E"
    scope:
      selection: "="
      allOptions: "="
      isDisabled: "="
      searchPlaceholder: "@"
    templateUrl: "tagSelector/directive.tagSelector.html"
    controller: [
      () ->

        view = @

        view.filter = ""
        view.filteredOptions = []
        view.selectedOptions = {}
        view.availableOptions = {}

        view.removeTag = (tag, $event) ->
          view.selection = view.selection.filter (_tag) ->
            _tag isnt tag
          # Prevent this from toggling the dropdown state
          $event.preventDefault()
          $event.stopImmediatePropagation()

        view.addTag = (tag) ->
          if view.selection.indexOf(tag) is -1
            view.selection.push(tag)
            view.filter = ""
            view.setInputFocus?()

        return view

    ]
    link: (scope, element) ->

      view = scope.view

      # Given an array of strings, returns an object with a truthy value for
      # each array item
      arrayToTruthyObject = (items) ->
        items.reduce (options, id) ->
          options[id] = true
          return options
        , {}

      scope.$watch "view.selection", () ->
        lowercaseSelection = view.selection.map (item) ->
          item.toLowerCase()
        view.selectedOptions = arrayToTruthyObject(lowercaseSelection)
      , true

      filterCollection = (collection, query) ->
        name: collection.name
        options: collection.options.filter (tag) ->
          tag.name.toLowerCase().indexOf(query) >= 0

      filterCollections = (collections, query) ->
        collections.map (collection) ->
          filterCollection(collection, query)
        .filter (collection) ->
          collection.options.length > 0

      updateFilteredOptions = () ->
        view.filteredOptions = filterCollections(view.allOptions ? [], view.filter.toLowerCase())
        availableOptionsArray = view.filteredOptions.reduce (options, category) ->
          options.concat(category.options.map(({id})->id.toLowerCase()))
        , []
        view.availableOptions = arrayToTruthyObject(availableOptionsArray)

      scope.$watch("view.filter", updateFilteredOptions)

      scope.$watch("view.allOptions", updateFilteredOptions, true)

      view.setInputFocus = () ->
        element.find("[tag-selector-search-input]").focus()
        return # Angular complains if we implicitly return a DOM element

      element.find("[rj-dropdown]").on("dropdownopen", view.setInputFocus)
        .on "dropdownclose", () ->
          scope.$applyAsync () ->
            view.filter = ""

]
